import { Expense, ExpenseFilter } from './types';
import { ExpenseGroup, ExpenseGroupType } from '../../__generated__/graphql';

export const applyExpenseFilter = (
  filter: ExpenseFilter,
  expenses: Expense[],
): Expense[] => expenses.filter((x) => isMatchExpenseFilter(filter, x));

export const applyExpenseGroupFilter = <
  T extends Pick<ExpenseGroup, 'Id' | 'flair__Status__c' | 'flair__Type__c'>,
>(
  filter: ExpenseFilter,
  expenseGroups: T[],
  expenses: Expense[],
): T[] => {
  return expenseGroups.filter((group) => {
    if (filter.type !== null) {
      if (filter.type === 'individual') {
        return false;
      }
      if (
        filter.type === 'groups' &&
        group.flair__Type__c === ExpenseGroupType.Trip
      ) {
        return false;
      }
      if (
        filter.type === 'trips' &&
        group.flair__Type__c !== ExpenseGroupType.Trip
      ) {
        return false;
      }
    }

    const childExpenses = expenses.filter(
      (expense) => expense.flair__Expense_Group__c === group.Id,
    );

    if (childExpenses.length === 0) {
      return (
        filter.category === null &&
        filter.year === null &&
        filter.status === null
      );
    }

    return childExpenses.some((expense) =>
      isMatchExpenseFilter(filter, expense),
    );
  });
};

export const applyUngroupedExpenseFilter = (
  filter: ExpenseFilter,
  expenses: Expense[],
): Expense[] => {
  const ungroupedExpenses = expenses.filter(
    (expense) => !expense.flair__Expense_Group__c,
  );

  if (filter.type !== null && filter.type !== 'individual') {
    return [];
  }

  return ungroupedExpenses.filter((x) => isMatchExpenseFilter(filter, x));
};

const isMatchExpenseFilter = (
  filter: ExpenseFilter,
  expense: Expense,
): boolean => {
  if (filter.category !== null && expense.category?.Id !== filter.category) {
    return false;
  }
  if (filter.status !== null && expense.status !== filter.status) {
    return false;
  }

  if (filter.year !== null) {
    if (expense.expenseDate.getFullYear() !== parseInt(filter.year)) {
      return false;
    }
  }
  return true;
};
